import { SOFTWARE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: `${SOFTWARE_MNG}/relateTestCase`,
  params: null,
  extraParams: null,
  okAction: 'create',
  formatData(data) {
    data.softwareId = this.extraParams?.softwareId
    const relateTestCaseArr = data.relateTestCaseArr.map(item => {
      return item.id
    })
    data.testCaseIdList = relateTestCaseArr
    return data
  },
  view: {
    title: '关联用例',
    labelPosition: 'right',
    content: [
      {
        $id: 'relateTestCaseArr',
        label: '关联用例',
        $type: 'sky-relation-option',
        actions: {
          nativeOn: {
            click: 'softwareRelationTestCase'
          }
        },
        $el: {
          multiple: true
        },
        rules: [{ notEmpty: '关联用例' }]
      }
    ]
  }
}
